// LIST
export const FETCH_HOME_GROUP_STAFFS = "app/Staff/FETCH_HOME_GROUP_STAFFS";
export const FETCH_HOME_GROUP_STAFFS_SUCCESS =
  "app/Staff/FETCH_HOME_GROUP_STAFFS_SUCCESS";
export const FETCH_HOME_GROUP_STAFFS_FAILURE =
  "app/Staff/FETCH_HOME_GROUP_STAFFS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Staff/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Staff/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Staff/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_HOME_GROUP_STAFF = "app/Staff/ADD_HOME_GROUP_STAFF";
export const ADD_HOME_GROUP_STAFF_SUCCESS =
  "app/Staff/ADD_HOME_GROUP_STAFF_SUCCESS";
export const ADD_HOME_GROUP_STAFF_FAILURE =
  "app/Staff/ADD_HOME_GROUP_STAFF_FAILURE";
// EDIT
export const EDIT_HOME_GROUP_STAFF = "app/Staff/EDIT_HOME_GROUP_STAFF";
export const EDIT_HOME_GROUP_STAFF_SUCCESS =
  "app/Staff/EDIT_HOME_GROUP_STAFF_SUCCESS";
export const EDIT_HOME_GROUP_STAFF_FAILURE =
  "app/Staff/EDIT_HOME_GROUP_STAFF_FAILURE";
// DELETE
export const DELETE_HOME_GROUP_STAFF = "app/Staff/DELETE_HOME_GROUP_STAFF";
export const DELETE_HOME_GROUP_STAFF_SUCCESS =
  "app/Staff/DELETE_HOME_GROUP_STAFF_SUCCESS";
export const DELETE_HOME_GROUP_STAFF_FAILURE =
  "app/Staff/DELETE_HOME_GROUP_STAFF_FAILURE";
//
export const OPEN_STAFF_ADD_MODAL = "app/Staff/OPEN_STAFF_ADD_MODAL";
export const CLOSE_STAFF_ADD_MODAL = "app/Staff/CLOSE_STAFF_ADD_MODAL";

export const OPEN_STAFF_EDIT_MODAL = "app/Staff/OPEN_STAFF_EDIT_MODAL";
export const CLOSE_STAFF_EDIT_MODAL = "app/Staff/CLOSE_STAFF_EDIT_MODAL";
export const SET_STAFF_SUCCESS = "app/Staff/SET_STAFF_SUCCESS";
export const SET_STAFF_FAILURE = "app/Staff/SET_STAFF_FAILURE";

export const TOGGLE_INVITE_MODAL = "app/STAFF/TOGGLE_INVITE_MODAL";

export const INVITE_STAFF = "app/STAFF/INVITE_STAFF";
export const INVITE_STAFF_SUCCESS = "app/STAFF/INVITE_STAFF_SUCCESS";
export const INVITE_STAFF_FAILURE = "app/STAFF/INVITE_STAFF_FAILURE";
